var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.5057 14.4839C24.2495 19.1383 26.8691 27.2711 21.5055 31.4839C13.0352 38.1369 0.516123 20.9602 1.03568 13C1.47763 6.229 9.36824 3.98389 16.3773 3.98389C23.3864 3.98389 27.2774 7.91966 25.5057 14.4839Z",
    fill: "#52C41A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0089 13.7402H21.7526C21.4794 13.7402 21.2196 13.8715 21.0588 14.0965L16.8481 19.9358L14.941 17.2893C14.7803 17.067 14.5231 16.9331 14.2472 16.9331H12.991C12.8169 16.9331 12.7151 17.1313 12.8169 17.2733L16.1544 21.9018C16.2332 22.0119 16.3372 22.1016 16.4576 22.1634C16.578 22.2253 16.7114 22.2575 16.8468 22.2575C16.9822 22.2575 17.1156 22.2253 17.236 22.1634C17.3564 22.1016 17.4604 22.0119 17.5392 21.9018L23.1803 14.0804C23.2847 13.9384 23.183 13.7402 23.0089 13.7402Z",
    fill: "#096DD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6C11.3732 6 6 11.3732 6 18C6 24.6268 11.3732 30 18 30C24.6268 30 30 24.6268 30 18C30 11.3732 24.6268 6 18 6ZM18 27.9643C12.4982 27.9643 8.03571 23.5018 8.03571 18C8.03571 12.4982 12.4982 8.03571 18 8.03571C23.5018 8.03571 27.9643 12.4982 27.9643 18C27.9643 23.5018 23.5018 27.9643 18 27.9643Z",
    fill: "#096DD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.3ce77cebc99a2900ad51e537d416d165.svg";
export { ForwardRef as ReactComponent };